import { useInterval } from 'ahooks';
import classNames from 'classnames';
import { useState } from 'react';

/** 小于10补0 */
const formatNumber = (n: number) => (n < 10 ? `0${n}` : n);

/**
 * 把时间秒转换成时分秒
 * @param param0
 * @returns
 */
const formatTime = (time: number) => {
  const hour = Math.floor(time / 3600);
  const minute = Math.floor((time - hour * 3600) / 60);
  const second = time - hour * 3600 - minute * 60;
  return `${formatNumber(hour)}:${formatNumber(minute)}:${formatNumber(second)}`;
};

const CountDown = ({ time, finish, className }: { time: number; className?: string; finish?: () => void }) => {
  const [t, setTime] = useState<number>(time);

  const clear = useInterval(() => {
    if (t === 0) {
      clear();
      finish?.();
      return;
    }
    setTime(time => time - 1);
  }, 1000);

  return (
    <div
      className={classNames({
        [className ?? '']: className
      })}
    >
      {formatTime(t)}
    </div>
  );
};

export default CountDown;
